export const passwordRecovery = {
  Back: 'Voltar',
  'In order to recover your password, please provide the email used on your registration':
    'Para recuperar sua senha, por favor informe o email utilizado no seu cadastro',
  'Password Recovery': 'Recuperação de Senha',
  Send: 'Enviar',
  "We've sent an email with instructions on how the recover your password Check your inbox":
    'Enviamos um email com as instruções de recuperação da senha. Verifique sua caixa de entrada',
};
